namespace appn.devWidget {
    interface TicketNote {
        ticketNumber: string;
    }

    export function init(): void {

        // This makes sure that the controls work even when the page itself has inputs disabled
        $('.appnDevWidget input').removeAttr('disabled');
        $('.appnDevWidget input').removeAttr('readonly');

        addEvents();
    }

    function addEvents() {
        $('.btnExpandAllCards').on('click', function() {
            $('.collapsed-card.card [data-card-widget=\'collapse\']').click();
        });

        $('.btnCollapseAllCards').on('click', function() {
            $('.card:not(.collapsed-card) [data-card-widget=\'collapse\']').click();
        });
    }

    function getUserDevices(): Array<Array<string>> {
        const devices: Array<Array<string>> = [];

        const table = $('#userDevices').find('table');
        const rows = table.find('tbody').find('tr');

        rows.each((i, e) => {
            const userDevice = new Array<string>();

            userDevice.push($(e).children().get(0)?.innerText as string);
            userDevice.push($(e).children().get(1)?.innerText as string);
            userDevice.push($(e).children().get(2)?.innerText as string);
            userDevice.push($(e).children().get(3)?.innerText as string);
            userDevice.push($(e).find('button').attr('id') as string);
            
            devices.push(userDevice);
        });

        return devices;
    }

    export function widgetShortcut(event: Event): void {
        $('.btn-control-sidebar').click();
    }
}
